/* Jalecos Mania — painel "Vistos recentemente" do header.
   Lê o histórico do localStorage (jm-recent, alimentado nas páginas de produto),
   busca os dados leves de cada produto (/products/<handle>.js) e mostra num
   painel lateral no padrão da mini-sacola. Coração integra com a wishlist. */
(function () {
  var KEY = 'jm-recent';
  var botao = document.querySelector('[data-jm-recentes-open]');
  var painel = document.querySelector('[data-jm-recentes]');
  if (!botao || !painel) return;

  var backdrop = document.querySelector('[data-jm-recentes-backdrop]');
  var lista = painel.querySelector('[data-jm-recentes-lista]');
  var vazio = painel.querySelector('[data-jm-recentes-vazio]');
  var sub = painel.querySelector('[data-jm-recentes-sub]');
  var foot = painel.querySelector('[data-jm-recentes-foot]');
  var cache = {};

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }

  function syncBadge() {
    var n = read().length;
    document.querySelectorAll('[data-recentes-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  var brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  function fetchProduto(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) cache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function itemHTML(p) {
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?width=180' : '&width=180') : '';
    var precoAtual = brl.format(p.price / 100);
    var precoDe = p.compare_at_price && p.compare_at_price > p.price ? brl.format(p.compare_at_price / 100) : null;
    return (
      '<a class="jm-rc__item" href="' + p.url + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" width="66" height="82">' : '<span class="jm-rc__noimg"></span>') +
        '<span class="jm-rc__info">' +
          '<b>' + p.title + '</b>' +
          '<span class="jm-rc__preco">' + (precoDe ? '<s>' + precoDe + '</s>' : '') + '<strong>' + precoAtual + '</strong></span>' +
          (p.available
            ? '<small class="jm-rc__tag">Disponível</small>'
            : '<small class="jm-rc__tag jm-rc__tag--off">Esgotado</small>') +
        '</span>' +
        '<button type="button" class="jm-rc__heart" data-jm-rc-heart data-handle="' + p.handle + '" aria-label="Favoritar ' + p.title.replace(/"/g, '&quot;') + '">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.4-7-9.4A4 4 0 0 1 12 7a4 4 0 0 1 7 3.6c0 5-7 9.4-7 9.4Z"/></svg>' +
        '</button>' +
      '</a>'
    );
  }

  function syncHearts() {
    if (!window.JMWishlist) return;
    painel.querySelectorAll('[data-jm-rc-heart]').forEach(function (h) {
      var on = window.JMWishlist.has(h.getAttribute('data-handle'));
      h.classList.toggle('is-active', on);
      h.setAttribute('aria-pressed', String(on));
    });
  }

  function render() {
    var handles = read();
    // não mostra o produto da página atual (a pessoa já está nele)
    var atual = (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (atual) handles = handles.filter(function (h) { return h !== decodeURIComponent(atual); });

    if (!handles.length) {
      lista.innerHTML = '';
      vazio.hidden = false;
      foot.hidden = true;
      if (sub) sub.hidden = true;
      return;
    }

    lista.innerHTML = '<div class="jm-rc__skeleton"></div><div class="jm-rc__skeleton"></div><div class="jm-rc__skeleton"></div>';
    Promise.all(handles.map(fetchProduto)).then(function (produtos) {
      var validos = produtos.filter(Boolean);
      if (!validos.length) {
        lista.innerHTML = '';
        vazio.hidden = false;
        foot.hidden = true;
        return;
      }
      vazio.hidden = true;
      foot.hidden = false;
      lista.innerHTML = validos.map(itemHTML).join('');
      if (sub) {
        sub.hidden = false;
        sub.textContent = validos.length === 1 ? '1 produto' : validos.length + ' produtos';
      }
      syncHearts();
    });
  }

  function abrir() {
    render();
    painel.classList.add('is-open');
    painel.setAttribute('aria-hidden', 'false');
    botao.setAttribute('aria-expanded', 'true');
    if (backdrop) {
      backdrop.hidden = false;
      requestAnimationFrame(function () { backdrop.classList.add('is-open'); });
    }
    document.documentElement.style.overflow = 'hidden';
  }

  function fechar() {
    painel.classList.remove('is-open');
    painel.setAttribute('aria-hidden', 'true');
    botao.setAttribute('aria-expanded', 'false');
    if (backdrop) {
      backdrop.classList.remove('is-open');
      window.setTimeout(function () { backdrop.hidden = true; }, 320);
    }
    document.documentElement.style.overflow = '';
  }

  botao.addEventListener('click', function () {
    if (painel.classList.contains('is-open')) fechar();
    else abrir();
  });
  painel.querySelectorAll('[data-jm-recentes-close]').forEach(function (b) { b.addEventListener('click', fechar); });
  if (backdrop) backdrop.addEventListener('click', fechar);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && painel.classList.contains('is-open')) fechar();
  });

  // coração dentro do painel: favorita sem sair da lista
  painel.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('[data-jm-rc-heart]');
    if (!h) return;
    e.preventDefault();
    e.stopPropagation();
    if (window.JMWishlist) window.JMWishlist.toggle(h.getAttribute('data-handle'));
  });
  document.addEventListener('jm:wishlist:change', syncHearts);

  // limpar histórico
  var limpar = painel.querySelector('[data-jm-recentes-limpar]');
  if (limpar) {
    limpar.addEventListener('click', function () {
      try { localStorage.setItem(KEY, '[]'); } catch (e) {}
      syncBadge();
      render();
    });
  }

  syncBadge();
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) syncBadge();
  });
})();
